var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center mt-16"},[_c('div',{staticClass:"text-center text-black-50"},[_c('p',{staticClass:"mdi mdi-chat-alert mdi-48px"}),_c('h5',[_vm._v("لا يوجد رسائل حتى الأن لعرضها ...")])])])
}]

export { render, staticRenderFns }